export default __webpack_public_path__ + "static/heldane-text-medium-95214736ad3e99e0cba06165a4f2af1f.woff2";